import {
    freFastSearchEmailButtonLabel,
    freFastSearchFavoriteButtonLabel,
} from './FastSearchScene.locstring.json';
import loc from 'owa-localize';

import { observer } from 'mobx-react-lite';
import * as React from 'react';

const styles = require('./OptInScene.scss');
const classNames = require('classnames/bind').bind(styles);

export default observer(function FastSearch(props: {}) {
    return (
        <div>
            <div className={classNames('prop', 'ui-stage')} />
            <div className={classNames('prop', 'focused-header-bar')} />
            <div className={classNames('prop', 'focused-search-field')} />
            <div className={classNames('prop', 'search-dropdown-plate')} />
            <div className={classNames('prop', 'cancel-arrow')} />
            <div className={classNames('prop', 'list-view-blocker')} />

            <div className={classNames('prop', 'contact-card')}>
                <span className={classNames('display-name')}>Robin Counts</span>
                <span className={classNames('email-address')}>robincounts@outlook.com</span>
                <div className={classNames('floated-actions', 'clear')}>
                    <span className={classNames('action', 'email')}>
                        {loc(freFastSearchEmailButtonLabel)}
                    </span>
                    <span className={classNames('action', 'favorite')}>
                        {loc(freFastSearchFavoriteButtonLabel)}
                    </span>
                </div>
            </div>

            <div className={classNames('prop', 'inputted-character', 'first')}>R</div>
            <div className={classNames('prop', 'inputted-character', 'second')}>o</div>
            <div className={classNames('prop', 'resolved-suggestion')}>Robin Counts</div>

            <div className={classNames('prop', 'results-list', 'default')}>
                <ul className={classNames('results')}>
                    <li className={classNames('robert')}>Robert Tolbert</li>
                    <li className={classNames('miguel')}>Miguel Garcia</li>
                    <li className={classNames('wanda')}>Wanda Howard</li>
                    <li>meeting notes</li>
                </ul>
            </div>

            <div className={classNames('prop', 'results-list', 'first')}>
                <ul className={classNames('results')}>
                    <li className={classNames('robin')}>
                        <mark>R</mark>obin Counts
                    </li>
                    <li className={classNames('robert')}>
                        <mark>R</mark>obert Tolbert
                    </li>
                    <li className={classNames('miguel')}>
                        Miguel Ga<mark>r</mark>cia
                    </li>
                    <li className={classNames('wanda')}>
                        Wanda Howa<mark>r</mark>d
                    </li>
                </ul>
            </div>

            <div className={classNames('prop', 'results-list', 'second')}>
                <ul className={classNames('results')}>
                    <li className={classNames('robin', 'hovered')}>
                        <mark>Ro</mark>bin Counts
                    </li>
                    <li className={classNames('robert')}>
                        <mark>Ro</mark>bert Tolbert
                    </li>
                    <li>
                        <mark>ro</mark>mex
                    </li>
                    <li>
                        <mark>ro</mark>bert’s crossword
                    </li>
                </ul>
            </div>
        </div>
    );
});
